export const PORTFOLIO_HUB = 'portfolio';
export const RECEIVE_PORTFOLIO_EVENT = 'ReceivePortfolioEvent';
export const RECEIVE_SYNC_EVENT = 'ReceiveSyncEvent';

export const NOTIFICATION_HUB = 'notification';
export const RECEIVE_NOTIFICATION = 'ReceiveNotification';
